export default __webpack_public_path__ + "static/blockchain-d950cc5c3b3766c81b03f63c43c03743.png";